<template>
    <div>
        <div class="px-1 text-left mb-1">
            <p v-if="transactionSummary.processNumber" class="text-muted small">
                <b>{{ transactionSummary.processNumber }}</b> numaralı yakıt çıkış işlemini onaylamak üzeresiniz. Lütfen detayları kontrol ediniz.
            </p>
        </div>

        <div class="px-1 mb-2">
            <div class="border rounded p-1 summary-card">
                <div class="summary-section">
                    <div class="d-flex align-items-center">
                        <feather-icon icon="TruckIcon" size="16" class="text-muted mr-1" />
                        <span>
                            {{ transactionSummary.plate }}
                            <span v-if="transactionSummary.trailerPlate" class="text-muted"> / {{ transactionSummary.trailerPlate }}</span>
                        </span>
                    </div>
                    <div class="d-flex align-items-center">
                        <feather-icon icon="UserIcon" size="16" class="text-muted mr-1" />
                        <span>{{ transactionSummary.driverName }}</span>
                    </div>
                    <div v-if="transactionSummary.vehicleKM > 0" class="d-flex align-items-center">
                        <feather-icon icon="TrendingUpIcon" size="16" class="text-muted mr-1" />
                        <span>{{ transactionSummary.vehicleKM.toLocaleString("tr-TR") }} km</span>
                    </div>
                </div>

                <hr class="my-1" />

                <div class="summary-section">
                    <div v-for="(detail, index) in transactionSummary.details" :key="index" class="d-flex justify-content-between">
                        <div class="d-flex align-items-center">
                            <feather-icon icon="DropletIcon" size="16" class="text-primary mr-1" />
                            <span v-b-tooltip.hover.top="detail.depotName" class="fuel-detail-text">
                                {{ detail.fuelTypeName }} <small class="text-muted">({{ detail.depotName }})</small>
                            </span>
                        </div>
                        <strong class="text-info">{{ detail.quantity }} lt</strong>
                    </div>
                </div>

                <hr class="my-1" />
                <div class="d-flex justify-content-between font-weight-bold">
                    <span>TOPLAM MİKTAR:</span>
                    <span class="text-danger h5 mb-0">{{ transactionSummary.totalQuantity }} lt</span>
                </div>
            </div>
        </div>

        <div class="px-1 action-area">
            <div class="ml-auto">
                <div class="col-12">
                    <div class="text-center">
                        <small class="text-muted">Kalan Süre</small>
                        <div v-if="remainingTime > 0" class="timer-display">
                            {{ timerDisplay }}
                        </div>
                        <div v-else class="timer-display text-danger small">Süre Doldu</div>
                    </div>
                </div>
                <div class="col-12">
                    <div class="form-group mb-0">
                        <label for="sms-code" class="font-weight-bold">Doğrulama Kodu</label>
                        <input
                            id="sms-code"
                            ref="smsInput"
                            :value="value"
                            type="text"
                            class="form-control form-control-lg text-center"
                            :class="{ 'bg-light': isInputDisabled }"
                            :disabled="isInputDisabled"
                            placeholder="_ _ _ _ _ _"
                            maxlength="6"
                            @input="$emit('input', $event.target.value)"
                            @keyup.enter="$emit('enter-pressed')"
                        />
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { BCard, VBTooltip } from "bootstrap-vue";

export default {
    name: "SmsVerificationModalContent",
    components: {
        BCard,
    },
    directives: {
        "b-tooltip": VBTooltip,
    },
    props: {
        value: {
            type: String,
            default: null,
        },
        timeoutSeconds: {
            type: Number,
            default: 300,
        },
        transactionSummary: {
            type: Object,
            default: () => ({}),
        },
    },
    data() {
        return {
            remainingTime: this.timeoutSeconds,
            timerId: null,
            isExpired: false,
        };
    },
    computed: {
        timerDisplay() {
            const minutes = Math.floor(this.remainingTime / 60);
            const seconds = this.remainingTime % 60;
            return `${String(minutes).padStart(2, "0")}:${String(seconds).padStart(2, "0")}`;
        },
        isInputDisabled() {
            return this.isExpired || this.remainingTime <= 0;
        },
    },
    methods: {
        focusInput() {
            this.$refs.smsInput?.focus();
        },
        startTimer() {
            this.stopTimer();
            this.remainingTime = this.timeoutSeconds;
            this.isExpired = false;

            this.timerId = setInterval(() => {
                if (this.remainingTime > 0) {
                    this.remainingTime -= 1;
                } else {
                    this.stopTimer();
                    this.isExpired = true;
                    this.$emit("timer-expired");
                }
            }, 1000);
        },
        stopTimer() {
            if (this.timerId) {
                clearInterval(this.timerId);
                this.timerId = null;
            }
        },
    },
    beforeDestroy() {
        this.stopTimer();
    },
};
</script>
<style>
.summary-card {
    background-color: #f8f9fa;
    font-size: 0.9rem;
}
.summary-section {
    display: flex;
    flex-direction: column;
    gap: 0.5rem;
}
.fuel-detail-text {
    max-width: 250px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}
.action-area {
    margin-top: 1.5rem;
}
.timer-display {
    font-size: 1.5rem;
    font-weight: 500;
    letter-spacing: 1px;
}
</style>
